import { Box } from '@mui/material';
import { useContentCards } from '../hooks';
import { CustomContentCard } from './CustomContentCard';

export const BrazeContentFeed = () => {
  const { contentCards, logCardClick, logCardDismissal } = useContentCards();

  if (!contentCards.length) return null;

  return (
    <Box sx={{ width: '100%', mt: 10 }}>
      {contentCards.map(card => (
        <CustomContentCard
          key={card.id}
          card={card}
          onCardClick={logCardClick}
          onCardDismiss={logCardDismissal}
        />
      ))}
    </Box>
  );
};
